import { Server, Database, Zap, Code, Layers, Github, Sparkles } from 'lucide-react';

export const skills = [
  { category: "Backend", items: ["Laravel", "Django", "PHP", "Python"], icon: Server, color: "emerald" },
  { category: "Database", items: ["MySQL", "PostgreSQL"], icon: Database, color: "blue" },
  { category: "APIs & Auth", items: ["RESTful APIs", "Sanctum", "Google Auth", "OTP", "JWT"], icon: Zap, color: "amber" },
  { category: "DevOps", items: ["Docker", "Linux", "Nginx", "CI/CD"], icon: Code, color: "rose" },
  { category: "Frontend", items: ["HTML", "CSS", "JavaScript", "Bootstrap", "React (Basic)"], icon: Layers, color: "violet" },
  { category: "Version Control", items: ["Git", "GitHub", "GitLab"], icon: Github, color: "slate" },
  { category: "Real-time", items: ["Pusher", "WebSockets", "Notifications"], icon: Sparkles, color: "cyan" }
];

export const techStack = [
  { name: "PHP", level: 80, category: "backend" },
  { name: "Laravel", level: 85, category: "backend" },
  { name: "Python", level: 70, category: "backend" },
  { name: "Django", level: 70, category: "backend" },
  { name: "MySQL", level: 80, category: "backend" },
  { name: "HTML", level: 50, category: "frontend" },
  { name: "CSS", level: 50, category: "frontend" },
  { name: "JavaScript", level: 45, category: "frontend" },
  { name: "React", level: 30, category: "frontend" },
];
